// Получаем CURRENT_LANGUAGE_CODE из window или meta-тега
const getCurrentLanguageCode = () => {
  if (typeof window !== 'undefined' && window.CURRENT_LANGUAGE_CODE) {
    return window.CURRENT_LANGUAGE_CODE;
  }
  if (typeof document !== 'undefined') {
    const metaTag = document.querySelector('meta[name="language-code"]');
    if (metaTag) {
      return metaTag.getAttribute('content') || 'en';
    }
  }
  return 'en'; // International fallback when no page language is available.
};

export const CURRENT_LANGUAGE_CODE = getCurrentLanguageCode();

